export default __webpack_public_path__ + "static/media/carousel_3_768.44d74c26.webp";